import React from 'react';

import {
  DollarIcon,
  LockIcon,
  SafetyIcon,
  UnlockIcon,
  WalletIcon,
} from 'app/shared/componentsRestyled/coreDesignSystem/icons';

import { ValueStub } from 'constants/data';
import { PricingUpdateRequestType } from 'constants/loanApplication';
import { loanPurposeOptionsMap } from 'constants/options';
import { StatusColor, StatusEnum } from 'constants/status';
import { getConditionalArray } from 'utils/data';
import { formatNumberToFixed3Decimals } from 'utils/number';
import { getModifiedFieldChangeKind } from 'utils/pendingChangeKind';

import { SummaryCardsName } from './Summary.constants';

const getLockHoverContent = pricingStatus => {
  if (!pricingStatus) {
    return;
  }

  const { isLocked, isLockPending, updateRequests = [] } = pricingStatus;

  const hasLockExtensionPending = updateRequests.some(
    request =>
      request.type === PricingUpdateRequestType.LOCK_EXTENSION_REQUEST &&
      request.completed === false,
  );

  if (hasLockExtensionPending) {
    return 'Lock Extension pending';
  }

  if (isLocked) {
    return 'Locked';
  }

  if (isLockPending) {
    return 'Lock pending';
  }
};

export const getSummaryConfig = ({
  program,
  purpose,
  interestRate,
  mortgageInsurance,
  pricingStatus,
  isUnsecured = false,
  isChattel = false,
}) => {
  const hideMortgageInsurance = isUnsecured || isChattel;
  const lockHoverContent = getLockHoverContent(pricingStatus);

  return [
    {
      name: SummaryCardsName.PROGRAM,
      value: program?.programName || ValueStub.COMMON,
      icon: <WalletIcon />,
      changeKind: getModifiedFieldChangeKind(program, 'ProgramName'),
      modifiedFieldDetails: program?.modifiedFieldDetails ?? null,
      pendingChangesKey: 'ProgramName',
      isClickable: true,
    },
    ...getConditionalArray(!isUnsecured, () => [
      {
        name: SummaryCardsName.PURPOSE,
        value: loanPurposeOptionsMap[purpose?.loanPurpose]?.name,
        icon: <DollarIcon />,
        changeKind: getModifiedFieldChangeKind(purpose, 'LoanPurpose'),
        modifiedFieldDetails: purpose?.modifiedFieldDetails ?? null,
        pendingChangesKey: 'LoanPurpose',
      },
    ]),
    {
      name: SummaryCardsName.INTEREST_RATE,
      value: `${formatNumberToFixed3Decimals(interestRate?.interestRate)}%`,
      icon: interestRate?.lockExpiration ? <LockIcon /> : <UnlockIcon />,
      iconColor: interestRate?.lockExpiration
        ? StatusColor[StatusEnum.SUCCESS]
        : StatusColor[StatusEnum.WARNING],
      changeKind: getModifiedFieldChangeKind(interestRate, 'InterestRate'),
      modifiedFieldDetails: interestRate?.modifiedFieldDetails ?? null,
      pendingChangesKey: 'InterestRate',
      isClickable: true,
      hoverContent: lockHoverContent,
    },
    ...getConditionalArray(!hideMortgageInsurance, [
      {
        name: SummaryCardsName.MORTGAGE_INSURANCE,
        value: mortgageInsurance?.hasMi ? 'Yes' : 'No',
        icon: <SafetyIcon />,
        isClickable: mortgageInsurance?.hasMi,
      },
    ]),
  ];
};
